module.exports = __webpack_public_path__ + "static/one-2a9106912ae6daf5ea51a6f8517c545f.png";